/*
-------------------------------------------------------------------------------------
Authors         : Alinsonorin, John Myl B., Awi, Joseph Kahl L., Gozon, Daniel Allan
Date Created    : April 30, 2025
Folder          : src/components/homepage/index
File            : Homepage.tsx
Description     : 
    This component allows the user to access the homepage of the web app.
Copyright © 2025. All rights reserved.
-------------------------------------------------------------------------------------
*/




// Imports MUI Components
import {
  Box,
  Grid,
  Stack
} from "@mui/material"

// Import Atoms
import ButtonComp from "../../../atoms/button/Button.jsx"

// Import Molecules
import HeaderHoverableLogo from '../../../molecules/header/HeaderHoverableLogo.jsx'
import HeaderButtonGroup from '../../../molecules/header/HeaderButtonGroup.jsx'
import FooterCard from "../../../molecules/footer/FooterCard.jsx"
import FooterCredits from "../../../molecules/footer/FooterCredits"
import Hero from "../../../molecules/body/hero/Hero"
import Section from "../../../molecules/body/about/Section.jsx"
import Insurance from "../../../molecules/body/insurance/Insurance.jsx"

const Body = () => {

  const boxStylesWrapper = {
    // width: "100%",
    backgroundColor: "#FDF9F3",
    justifyContent: "center",
    alignItems: "center",
  }

  const boxStylesContent = {
    width: "100%",
    maxWidth: "1740px",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundColor: "transparent"
  }
  
  return (
    <>
      <Box
        sx={boxStylesWrapper}
      >

        <Box
          sx={boxStylesContent}
        >

          <Hero
            index={false}
            title="Excellence in Dental Care"
            subtitle="
              At VSDiamond Dental Clinic, we combine advanced technology with compassionate care to deliver exceptional dental services. Your smile is our priority."/>

          <Section
            section="story"
            title="Our Story"
            card={true}/>

          <Section
            section="team"
            title="The Founders"/>

          <Section
            section="testimonials"
            title="Patient Testimonials"/>
            
        </Box>
      </Box>
    </>
  )

}

export default Body;